import script from "./StudentListPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentListPage.vue?vue&type=script&setup=true&lang=js"

import "./StudentListPage.vue?vue&type=style&index=0&id=2882d065&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2882d065"]])

export default __exports__